



import {Component, Vue} from 'vue-property-decorator'
import ItemsList from '@/components/items/ItemsList.vue'
import {Getter, Mutation} from 'vuex-class'

@Component({
  components: {
    ItemsList,
  },
})
export default class Items extends Vue {}
